export enum ParcelTypeEnums {
  INDIVIDUAL = "INDIVIDUAL",
  SPLIT = "SPLIT_ORDER",
  BULK = "BULK",
}

export enum ParcelStatusIssue {
  INVALID_RECIPIENT_ADDRESS = "INVALID RECIPIENT ADDRESS"
}

export const ParcelStatusByPage = {
  NEW: ["OPEN"],
  DIOLKO_PICKUP: ["OPEN", "PICKUP_IN_PROGRESS"],
  CUSTOMER_CONFIRMATION: ["PENDING_CONFIRMATION"],
  DIOLKO_REVIEW: ["PENDING_REVIEW", "RETURNED"],
  DISPATCH_READY: ["PENDING_PICKUP", "PENDING_DROPOFF"],
  CUSTOMER_DROPOFF: ["DROP_OFF_IN_PROGRESS"],
  REJECTED_ORDERS: ["REJECTED"],
  CANCELLED_ORDERS: ["CANCELLED"],
}

export const tabStatus = {
  0: ["OPEN"],
  1: ["PENDING_CONFIRMATION"],
  2: ["PENDING_REVIEW", "RETURNED"],
  3: ["PENDING_PICKUP", "PENDING_DROP_OFF"],
  4: [
    "PICKUP_IN_PROGRESS",
    "DROP_OFF_IN_PROGRESS",
    "PICKED_UP",
    "PENDING_PICKUP",
    "DROPPED_OFF",
    "PENDING_DROP_OFF",
  ],
  5: ["REJECTED"],
  6: ["CANCELLED"],
};

export enum OperationHoursTimeEnums {
  OPENING_TIME = "openingTime",
  CLOSING_TIME = "closingTime",
}

export const HasMultipleGoods = [ParcelTypeEnums.BULK];

export const GoodsHasTrackingNo = [ParcelTypeEnums.BULK, ParcelTypeEnums.SPLIT];

export const SameOrderModel = [
  ParcelTypeEnums.INDIVIDUAL,
  ParcelTypeEnums.BULK,
];
